import { render, staticRenderFns } from "./access-control.vue?vue&type=template&id=0b9fc233"
import script from "./access-control.vue?vue&type=script&lang=ts"
export * from "./access-control.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports